import type { Creator } from './ambassador'
import type { Reward } from './reward'

export enum ClaimState {
	Invalid = 0,
	Pending = 1,
	Active = 2,
	Used = 3,
	Expired = 4,
}

export type Claim = {
	id: number
	creation_date: Date
	expiration_date: Date | null
	time_used: number
	status: string
	state: ClaimState
	creator: Creator
	reward: Reward
	code: string | null
}
